import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import api from '../../api';
import './index.css';

export default class BusinessPartnerObject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      businessPartner: this.props.businessPartner || {},
      viewMode: this.props.isCreating ? 'edit' : 'view',
    };
  }
  updateObject(attribute, value) {
    const { businessPartner } = this.state;
    businessPartner[attribute] = value
    this.setState({ businessPartner });
  }
  updateBusinessPartner() {
    const { businessPartner } = this.state;
    const { isCreating } = this.props;
    api.fetchAPI({
      method: isCreating ? 'post' : 'put',
      uri: 'business_partners',
      body: businessPartner,
      success: (response) => {
        if (response.status === 'ok') {
          this.setState({ viewMode: 'view', businessPartner: response.business_partner });
        } else {
          alert('Error: ' + response.error);
          console.log(response);
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
    this.setState({ viewMode: 'view' });
  }
  resetAPIKey() {
    const confirmation = window.confirm('Are you sure to reset the API key? This will break client API calls');
    if (!confirmation) return;
    const { businessPartner } = this.state;
    api.fetchAPI({
      method: 'post',
      uri: 'business_partners/api_key',
      body: businessPartner,
      success: (response) => {
        if (response.status === 'ok') {
          this.setState({ viewMode: 'view', businessPartner: response.business_partner });
        } else {
          alert('Error: ' + response.error);
          console.log(response);
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }
  _renderViewMode() {
    const { businessPartner } = this.state;
    return (
      <div className="user-object-main">
        <div className="user-object-top-info">
          <h5 className="user-email">{businessPartner.name}</h5>
        </div>
        <div className="user-object-extra-info">
          <p>API Key: {businessPartner.api_key}</p>
          <FormGroup>
            <Button color="info" onClick={() => this.setState({ viewMode: 'edit' })}>
              Edit
            </Button>{' '}
            <Button color="warning" onClick={() => this.resetAPIKey()}>
              Reset api key
            </Button>{' '}
            <Button color="danger" onClick={() => this.deleteUser()}>
              Delete
            </Button>
          </FormGroup>
        </div>
      </div>
    );
  }
  _renderEditMode() {
    const { businessPartner } = this.state;
    const { isCreating } = this.props;
    return (
      <div className="user-object-main">
        <div className="user-object-top-info--edit">
          <FormGroup>
            <Input
              value={businessPartner.name}
              onChange={(e) => this.updateObject('name', e.target.value)}
              placeholder="Name"
            />
          </FormGroup>
        </div>
        <div className="user-object-extra-info">
          <Button
            color="success"
            onClick={() => this.updateBusinessPartner()}
          >
            {isCreating ? 'Create' : 'Save'}
          </Button>
        </div>
      </div>
    );
  }
  render() {
    const { viewMode } = this.state;
    if (viewMode === 'view') {
      return this._renderViewMode();
    } else {
      return this._renderEditMode();
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/BusinessPartnerObject/index.js